import styled from "@emotion/styled";
import { motion, useCycle } from "framer-motion";
import React from "react";

const Content = styled(motion.div)`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
`;

const Logo = styled(motion.img)`
  width: 100px;
  height: 100px;
`;

export default function PageLoading(): JSX.Element {
  return (
    <Content>
      <Logo
        src="../images/berserkermail.png"
        animate={{ scale: 1.4 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      />
    </Content>
  );
}
